// Note (mkosarek) When used as the default value for a UUID field, these values
// have a special meaning.
export const gReservedUuids = {
  NONE: '',
  ALL: 'all',
  ANY: 'any',
  UNKNOWN: 'UNKNOWN'
};
